import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import SsoLogoutPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createSsoLogoutScreen = ({ loginLink }) => {
  const domId = 'ssoLogoutPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <SsoLogoutPanel loginLink={loginLink} />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createSsoLogoutScreen = createSsoLogoutScreen;
